<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
          <label class="d-flex align-items-center">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.md]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'">
            <label class="d-flex align-items-center"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a class="btn btn-outline-primary text-primary" *ngIf="_authenticationService.hasCapability('create_role')" (click)="modalOpen(modalRoleAdd, null)">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="60" [limit]="tableLimit" [footerHeight]="60" [rows]="rolesList()">
          <ngx-datatable-column [name]="'FIRSTNAME' | translate" prop="name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'NUMBER_USERS' | translate" prop="users" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.users }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ORDER' | translate" prop="order" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.order }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <button class="bg-transparent border-0 text-secondary pr-1" (click)="modalOpen(modalroleEdit, row)" *ngIf="_authenticationService.hasCapability('edit_role')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteRole(row)" *ngIf="_authenticationService.hasCapability('delete_role')" class="bg-transparent border-0 text-danger remove-item">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'FIRSTNAME' | translate" prop="name" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="list-item-mobile row">
                <div class="col-9 px-0">
                  <span>{{ row.name }}</span>
                </div>
                <div class="col-3 d-flex px-0">
                  <button class="bg-transparent border-0 text-secondary" (click)="modalOpen(modalroleEdit, row)" *ngIf="_authenticationService.hasCapability('edit_role')">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button (click)="deleteRole(row)" *ngIf="_authenticationService.hasCapability('delete_role')" class="bg-transparent border-0 text-danger remove-item">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal Edit -->
<ng-template #modalroleEdit let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "EDIT" | translate }} {{ "ROLE" | translate }}</h3>
      <div class="form-group">
        <label [for]="'editRole'">{{ "ROLE" | translate }}<sup class="text-danger">*</sup></label>
        <input placeholder="Inserire ruolo" name="editRole" [(ngModel)]="currentRoles.name" type="text" [id]="'editRole'" class="form-control" />
        <div class="font-error" *ngIf="showErrors && (!currentRoles.name || currentRoles.name.length < 1)">{{ "ERRORS.FIELD_ROLE" | translate }}</div>
      </div>
      <div class="form-group">
        <label [for]="'editOrder'">{{ "ORDER" | translate }}<sup class="text-danger">*</sup></label>
        <input placeholder="Inserire un numero" name="editOrder" [(ngModel)]="currentRoles.order" type="number" [id]="'editOrder'" class="form-control" />
        <div class="font-error" *ngIf="showErrors && (!currentRoles.order || currentRoles.order < 1)">{{ "ERRORS.FIELD_ORDER" | translate }}</div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
        {{ "ALERT.BTN_CANCEL" | translate }}
      </button>
      <button (click)="editRole()" type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "EDIT" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Add -->
<ng-template #modalRoleAdd let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "ADD" | translate }} {{ "ROLE" | translate }}</h3>
      <div class="form-group">
        <label [for]="'newRole'">{{ "ROLE" | translate }}<sup class="text-danger">*</sup></label>
        <input placeholder="Inserire ruolo" name="newRole" [(ngModel)]="newRole" type="text" [id]="'newRole'" class="form-control" />
        <div class="font-error" *ngIf="showErrors && (!newRole || newRole.length < 1)">{{ "ERRORS.FIELD_ROLE" | translate }}</div>
      </div>
      <div class="form-group">
        <label [for]="'newOrder'">{{ "ORDER" | translate }}<sup class="text-danger">*</sup></label>
        <input placeholder="Inserire un numero" name="newOrder" [(ngModel)]="newOrder" type="number" [id]="'newOrder'" class="form-control" />
        <div class="font-error" *ngIf="showErrors && (!newOrder || newOrder < 1)">{{ "ERRORS.FIELD_ORDER" | translate }}</div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
        {{ "ALERT.BTN_CANCEL" | translate }}
      </button>
      <button (click)="addRole()" type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Add -->
